// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VcY32pwVfLSRGLfBc5nM9g\\=\\= strong{font-weight:700}", "",{"version":3,"sources":["webpack://./resources/js/components/FIlterItem/DisctrictFilter/DistrictsList/styles.module.scss"],"names":[],"mappings":"AACI,mCACI,eAAR","sourcesContent":[".list_item {\n    strong {\n        font-weight: bold;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list_item": "VcY32pwVfLSRGLfBc5nM9g=="
};
export default ___CSS_LOADER_EXPORT___;
